var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag-4-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 5.00004H12.5C12.5 3.61933 11.3807 2.50004 10 2.50004C8.61925 2.50004 7.5 3.61933 7.5 5.00004ZM5.83333 5.00004C5.83333 2.69886 7.69882 0.833374 10 0.833374C12.3012 0.833374 14.1667 2.69886 14.1667 5.00004H16.6667C17.1269 5.00004 17.5 5.37314 17.5 5.83337V17.5C17.5 17.9603 17.1269 18.3334 16.6667 18.3334H3.33333C2.8731 18.3334 2.5 17.9603 2.5 17.5V5.83337C2.5 5.37314 2.8731 5.00004 3.33333 5.00004H5.83333ZM4.16667 6.66671V16.6667H15.8333V6.66671H4.16667ZM7.5 8.33337C7.5 9.71412 8.61925 10.8334 10 10.8334C11.3807 10.8334 12.5 9.71412 12.5 8.33337H14.1667C14.1667 10.6345 12.3012 12.5 10 12.5C7.69882 12.5 5.83333 10.6345 5.83333 8.33337H7.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping_bag.f312633e18552667bbf1bff337af2298.svg";
export { ForwardRef as ReactComponent };